export const EASE_OUT: [number, number, number, number] = [0.22, 1, 0.36, 1]

export const EASE_OUT_EXPO: [number, number, number, number] = [0.16, 1, 0.3, 1]

// Shared "fade up when it scrolls into view" settings for motion elements.
export const getRevealProps = (delay = 0, y = 40, x = 0) => ({
    initial: { opacity: 0, y, x },
    whileInView: { opacity: 1, y: 0, x: 0 },
    viewport: { once: true, margin: '0px 0px -12% 0px' as const },
    transition: { duration: 0.9, ease: EASE_OUT, delay }
})
